import { createProfileState } from '@rango-dev/internal-profile/store';

const profileState = createProfileState();
export const profileSlice = profileState.slice;
export const {
  logInUser,
  logOutUser,
  clearAuthError,
  resetMergeStatus,
  resetUserData,
  resetUpdateUsernameError,
} = profileSlice.actions;

export const ProfileReducer = profileSlice.reducer;

export const {
  signMessage,
  fetchProfileSummary,
  fetchProfileDetails,
  fetchProfileLeaderboard,
  fetchPublicLeaderboard,
  fetchTopPublicLeaderboard,
  updateUsername,
  requestLogOutUser,
} = profileState.thunks;

export {
  profileSliceInitialState,
  showPrivateProfileSelector,
} from '@rango-dev/internal-profile/store';

export { dispatchCancellableAction, cancelProfileActions } from './helpers';
